import { MapPin } from "lucide-react";
import { useTenant } from "@/tenant/TenantProvider";
import TenantMark from "@/components/TenantMark";
import { TENANT } from "@/constants/testIds";

/**
 * The storefront's one header: the restaurant's name and place on the left,
 * its mark on the right. Welcome and the path chooser both open with it, so
 * the first two screens read as one place rather than two designs — anything
 * a screen adds (sign-in, avatar) slots in through `right`, before the mark.
 */
const TenantHeader = ({ right = null, className = "mb-10" }) => {
  const { restaurant } = useTenant();
  return (
    <div className={`flex items-center justify-between gap-3 ${className}`}>
      <div className="flex items-center gap-3 min-w-0">
        <TenantMark />
        <div className="min-w-0">
          <div
            data-testid={TENANT.name}
            className="text-lg font-black tracking-tight text-neutral-900 truncate"
          >
            {restaurant.name}
          </div>
          {restaurant.branding?.location && (
            <div className="flex items-center gap-1 mt-0.5 text-xs text-neutral-500 truncate">
              <MapPin size={12} className="shrink-0" /> {restaurant.branding.location}
            </div>
          )}
        </div>
      </div>
      {right && <div className="flex items-center gap-2 shrink-0">{right}</div>}
    </div>
  );
};

export default TenantHeader;
